var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignGradiant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 227,
    viewBox: "0 0 355 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 355,
    height: 227,
    rx: 17.0055,
    fill: "url(#paint0_linear_779_2191)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_779_2191",
    x1: -0.00000264496,
    y1: 113.5,
    x2: 355,
    y2: 113.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CB786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6423"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignGradiant);
export default __webpack_public_path__ + "static/media/designGradiant.2c31d10dbe1acab2f42027a10ed0f05c.svg";
export { ForwardRef as ReactComponent };